import React from 'react';
import './ConfirmationMessage.scss';
import { FormattedMessage } from 'react-intl';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import { DeliveryCode } from 'Store/Order/enums';
import DownloadConfirmationLink from 'Components/DownloadConfirmationLink/DownloadConfirmationLink';

interface IProps {
  orderID: number;
  deliveryCode?: DeliveryCode;
}

const ConfirmationMessage: React.SFC<IProps> = ({
  orderID,
  deliveryCode,
}) => {

  if (!orderID) {
    return null;
  }

  const DeliveryMessage = () => {
    switch(deliveryCode) {
      case DeliveryCode.E_TICKET:
        return (
          <FormattedText 
            displayName='Biljetterna skickas som en PDF till din e-postadress.'
            formattedName='order.confirmation.eticket'
          />
        );
      case DeliveryCode.TEXT_MESSAGE:
        return (
          <FormattedText 
            displayName='Biljetterna skickas som ett SMS till det angivna telefonnumret.'
            formattedName='order.confirmation.sms'
          />
        );
      case DeliveryCode.PICK_UP:
        return (
          <FormattedText 
            displayName='Biljetterna betalas och hämtas hos något av våra biljettombud.'
            formattedName='order.confirmation.pickup'
          />
        );
      case DeliveryCode.POSTCARD_REK:
        return (
          <FormattedText 
            displayName='Biljetterna skickas till dig som REK-brev till närmaste postombud.'
            formattedName='order.confirmation.rekpost'
          />
        );
      case DeliveryCode.POSTCARD_STANDARD:
        return (
          <FormattedText 
            displayName='Biljetterna skickas till dig som standardbrev.'
            formattedName='order.confirmation.standardpost'
          />
        );
    }
  };

  return (
    <div className='confirmation-message'>
      <FormattedText 
        style='title black'
        displayName='Tack för din beställning!'
        formattedName='order.confirmation.header'
      />
      <FormattedText 
        style='sub-title medium-bold'
        displayName='Nu är det bara det roliga kvar.'
        formattedName='order.confirmation.text'  
      />
      <FormattedMessage 
        id='order.confirmation.message'
        defaultMessage='En bokningsbekräftelse har skickats till din e-postadress.'
        values={ {  confirmationLink: <DownloadConfirmationLink { ... { orderID } } /> } }
      />
      <br />
      <DeliveryMessage />
      <span className='sub-title medium-bold order-id'>
        <FormattedMessage 
          id='order.confirmation.orderID'
          defaultMessage=''
          values={ { orderID } }
        />
      </span>
    </div>
  );
};

export default ConfirmationMessage;


// WEBPACK FOOTER //
// ./src/pages/OrderConfirmationPage/ConfirmationMessage/ConfirmationMessage.tsx